import React, { useEffect, useState } from "react";
import { Label, Radio, RadioGroup } from "@fluentui/react-components";
import { usePowder } from "../redux/ReduxContext";
import CustomSelect from "../CustomSelect";

const cardClass = "bg-white dark:bg-oi-dark-background p-4 mb-4 drop-shadow-md";
const labelClass = "mb-1 block text-[11px] font-semibold text-primary-dark dark:text-primary-light whitespace-nowrap";

const GEOMETRY_OPTIONS = ["SNUN"];
const PRESSURE_OPTIONS = ["123", "172", "221"];

export default function OiPowderPressing() {
    const { state, dispatch } = usePowder();

    useEffect(() => {
        if (state.geometry === "") {
            dispatch({ type: 'SET_FIELD', payload: { field: 'geometry', value: GEOMETRY_OPTIONS[0] } });
        }
        if (state.amount === "") {
            dispatch({ type: 'SET_FIELD', payload: { field: 'amount', value: "0" } });
        }
        if (state.pressPressure === "") {
            dispatch({ type: 'SET_FIELD', payload: { field: 'pressPressure', value: PRESSURE_OPTIONS[0] } });
        }
    }, [state, dispatch]);

    return (
        <div className={cardClass}>
            <div className="mb-2 text-sm font-bold">Pressing</div>

            <div className="mb-3">
                <Label className={labelClass}>Will the powder be used for inserts?</Label>
                <RadioGroup
                    layout="horizontal"
                    value={state.isUsedForInserts ? "yes" : "no"}
                    onChange={(_, data) => { dispatch({ type: 'SET_FIELD', payload: { field: 'isUsedForInserts', value: data.value === "yes" } }); console.log(state) }}
                >
                    <Radio value="yes" label="Yes" />
                    <Radio value="no" label="No" />
                </RadioGroup>
            </div>

            <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                <div>
                    <Label className={labelClass}>Geometry</Label>
                    <CustomSelect
                        className="border h-10"
                        value={state.geometry ? state.geometry : GEOMETRY_OPTIONS[0]}
                        onChange={(e) => dispatch({ type: 'SET_FIELD', payload: { field: 'geometry', value: e.target.value } })}
                    >
                        {/* <option disabled value="">
                            Select lot
                        </option> */}

                        {GEOMETRY_OPTIONS.map((option) => (
                            <option key={option} value={option}>{option}</option>
                        ))}
                    </CustomSelect>
                    {/* <select
                        value={state.geometry ? state.geometry : GEOMETRY_OPTIONS[0]}
                        onChange={(e) => dispatch({ type: 'SET_FIELD', payload: { field: 'geometry', value: e.target.value } })}
                        className="h-10 w-full border border-gray-300 dark:border-gray-600 bg-primary-light dark:bg-primary-dark px-3 focus:outline-none focus:ring-0"
                    >
                        {GEOMETRY_OPTIONS.map((option) => (
                            <option key={option} value={option}>{option}</option>
                        ))}
                    </select> */}
                </div>

                <div>
                    <Label className={labelClass}>Amount</Label>
                    <input
                        type="text"

                        className="h-10 w-full border border-gray-300 dark:border-gray-600 bg-primary-light dark:bg-primary-dark px-3 focus:outline-none focus:ring-0"
                        value={state.amount}
                        onChange={(e) => dispatch({ type: 'SET_FIELD', payload: { field: 'amount', value: e.target.value } })}
                    />
                </div>

                <div>
                    <Label className={labelClass}>Press pressure</Label>
                    <CustomSelect
                        className="border h-10"
                        value={state.pressPressure}
                        onChange={(e) => dispatch({ type: 'SET_FIELD', payload: { field: 'pressPressure', value: e.target.value } })}
                    >

                        {PRESSURE_OPTIONS.map((option) => (
                            <option key={option} value={option}>{option} MPa</option>
                        ))}
                    </CustomSelect>
                </div>
            </div>
        </div>
    );
};
